import Avatar from '../Avatar';
import Button from '../ui/Button';

export default function PeopleConnectionRow({
  profile,
  subtitle,
  isFollowing,
  isLoading,
  onFollow,
  onNavigate,
  showFollowActions = true,
}) {
  const displayName = profile.display_name?.trim() || profile.email?.split('@')[0] || 'Unknown';
  const mutualSubtitle =
    typeof profile.mutual_count === 'number' && profile.mutual_count > 0
      ? `${profile.mutual_count} mutual${profile.mutual_count === 1 ? '' : 's'}`
      : null;
  const detailLine = subtitle ?? mutualSubtitle;

  return (
    <div
      className="flex items-center justify-between gap-3 rounded-lg px-2 py-2 hover:bg-black/[0.03] dark:hover:bg-white/5 transition-colors cursor-pointer"
      onClick={onNavigate}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onNavigate()}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <Avatar displayName={displayName} profilePhotoUrl={profile.profile_photo_url} size="xs" />
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-gray-900 dark:text-dark-text glass-surface-text-emphasis">
            {displayName}
          </p>
          {detailLine ? (
            <p className="text-xs text-gray-500 dark:text-dark-muted glass-surface-subtle-text truncate">
              <span className="glass-surface-muted-chip">{detailLine}</span>
            </p>
          ) : typeof profile.followers_count === 'number' ? (
            <p className="text-xs text-gray-500 dark:text-dark-muted glass-surface-subtle-text">
              <span className="glass-surface-muted-chip">{profile.followers_count} followers</span>
            </p>
          ) : null}
        </div>
      </div>

      {showFollowActions &&
        (isFollowing ? (
          <span className="shrink-0 text-xs font-medium text-gray-500 dark:text-dark-muted">
            Following ✓
          </span>
        ) : (
          <Button
            type="button"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              onFollow();
            }}
            loading={isLoading}
            disabled={isLoading}
            className="shrink-0"
          >
            Follow
          </Button>
        ))}
    </div>
  );
}
